/*
Sandpaper
*/
import filters from '@/modules/standardItems/schemas/finish/filters'
import headers from '@/modules/standardItems/schemas/finish/headers'
import form from '@/modules/standardItems/schemas/finish/form'

const name = 'Sandpaper'
const id = '062dc5qCY3pm2ZnrndRV'

export default {
  name,
  id,
  filters,
  headers,
  form
}
